import { GoogleAuthProvider, sendSignInLinkToEmail, signInWithCustomToken, signInWithEmailAndPassword, signInWithEmailLink, signInWithPhoneNumber, signInWithPopup } from "firebase/auth";
import { serverTimestamp } from "firebase/firestore";
import _ from 'lodash';
import { signInResponseTypes, sirts } from "../../cnr/reducers/SignInReducer";
import { _collectionName_appUserValidation, _collectionName_passcodeValidation, _emailSignInStorageItem } from "../../cnr/reducers/ValidationReducer";
import { signInResponseData } from "../../cnr/reducers/reducerHelpers/signInProps";
import { gEnums } from "../../enums/globalEnums";
import { createRefPath } from "../../firestoreData/appData/appRefPaths";
import { currentHelpers } from "../../redirection/current";

const _testing = false
const _useLocalStorage = true

export const firebaseSignIns = (database_fns, mainAuth) => ({
  customToken: () => signIn_customToken(mainAuth),
  emailAndPassword: (authCreds) => signIn_emailAndPassword(mainAuth, authCreds),
  googleLink: () => signIn_googleLink(mainAuth),
  passcodeInLink: (fn_cls, validationCode, creds, appSignIn, signInEmail, callback, parentCallback) => sendSignIn_passcodeInLink(fn_cls, validationCode, creds, appSignIn, signInEmail, callback, parentCallback),
  phoneNumber: (phoneNumber, recaptchaVerifier, callback) => signIn_phoneNumber(mainAuth, phoneNumber, recaptchaVerifier, callback),
});

/**
 * This will call `signInWithPhoneNumber`, which will send an SMS with a code. The confirmationResult object will be returned.
 * The confirmationResult will have a confirmationResult.confirm object which will accept the confirmation code and finish the mainAuth process.
 * @param {string} phoneNumber 
 * @param {object} recaptchaVerifier 
 * @param {function} callback 
 */
const signIn_phoneNumber = (mainAuth, phoneNumber, recaptchaVerifier, callback) => {
  const _phoneNumber = _testing ? '+14125552081' : phoneNumber
  console.log('mainAuth', mainAuth)
  console.log('phoneNumber', phoneNumber)
  console.log('recaptchaVerifier', recaptchaVerifier)

  recaptchaVerifier.verify()
    .then(token => console.log("✅ Token received 2:", token))
    .catch(err => console.error("❌ Verify failed 3:", err));

  // signInWithPhoneNumber(mainAuth, _phoneNumber, recaptcha)
  //   .then(function (confirmationResult) {
  //     console.log('confirmationResult', confirmationResult)
  //     const _sirProps = { signInResponseType: signInResponseTypes.phoneCodeSent, confirmationResult }
  //     callback && callback(signInResponseData(_sirProps))
  //     // SMS sent. Prompt user to type the code from the message, then sign the
  //     // user in with confirmationResult.confirm(code).
  //     window.confirmationResult = confirmationResult;
  //   }).catch(function (error) {
  //     console.error('sendPhoneCode', error)
  //     // Error; SMS not sent
  //     const _sirProps = { signInResponseType: signInResponseTypes.phoneCodeNotSent, phoneNumber, error }
  //     callback && callback(signInResponseData(_sirProps))
  //     // ...
  //   });
}

const signIn_emailAndPassword = async (mainAuth, authCreds) => {

  const hsir = sirts.handleSignInResponse

  const creds = {
    email: authCreds.email.toLowerCase(),
    password: authCreds.password
  }

  return signInWithEmailAndPassword(mainAuth, creds.email, creds.password)
    .then(async (ref) => {
      return ({ type: hsir, signInResponseType: signInResponseTypes.signInSuccess, success: true });
    }).catch((err) => {
      if (err.code) {
        switch (err.code) {
          case 'auth/too-many-requests':
            return ({ type: hsir, signInResponseType: signInResponseTypes.tooManyAttempts, success: false });
          case 'auth/wrong-password':
            return ({ type: hsir, signInResponseType: signInResponseTypes.incorrectPassword, success: false });
          default:
            return ({ type: hsir, signInResponseType: signInResponseTypes.incorrectPassword, success: false });
        }
      } else {
        return ({ type: hsir, signInResponseType: signInResponseTypes.incorrectPassword, success: false });
      }
    })
}

/** Sends a email to the emailAddress.
 * If the recipient clicks on the 'Sign in to ...' link, they will be redirected to the url use below
 * @callback dispatch: type = handleSignInResponse
 */
const signIn_googleLink = async (mainAuth) => {

  const provider = new GoogleAuthProvider();

  signInWithPopup(mainAuth, provider)
    .then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      const credential = GoogleAuthProvider.credentialFromResult(result);
      console.log('credential', credential)
      // const token = credential.accessToken;
      // The signed-in user info.
      // const user = result.user;
      // IdP data available using getAdditionalUserInfo(result)
      // ...
    }).catch((error) => {
      // Handle Errors here.
      // const errorCode = error.code;
      // const errorMessage = error.message;
      // The email of the user's account used.
      // const email = error.customData.email;
      // The AuthCredential type that was used.
      // const credential = GoogleAuthProvider.credentialFromError(error);
      // ...
    })
}

const signIn_customToken = async (mainAuth, token, callback) => {

  const hsir = sirts.handleSignInResponse

  signInWithCustomToken(mainAuth, token)
    .then((userCredential) => {
      // Signed in
      const user = userCredential.user;
      return ({ type: hsir, signInResponseType: signInResponseTypes.signInSuccess, user, success: true });
      // ...
    })
    .catch((error) => {
      // const errorCode = error.code;
      // const errorMessage = error.message;
      return ({ type: hsir, signInResponseType: signInResponseTypes.unknownError, success: false });
      // ...
    });
}

const sendSignIn_passcodeInLink = async (fn_cls, validationCode, creds, appSignIn, signInEmail, callback, parentCallback) => {

  // const {  result } = res ?? {}
  // const { customToken } = result ?? {}
  const { email } = creds

  const { logSignInAttemptsToDatabase } = appSignIn ?? {}

  const dispatchSuccessType = signInResponseTypes.emailLinkSent
  const dispatchNonSuccessType = signInResponseTypes.emailLinkNotSent

  const params = {
    isEmailLink: true,
    emailSignInConfirmation: true,
    openInSamePWA: true,
    email,
  }

  if (email) {
    const { signInBody, signInSubject, signInBodyLinkText, pwaAppName } = signInEmail ?? {}
    const notificationData = {
      email: email,
      subject: signInSubject ? signInSubject : 'Sign into the App',
      body: signInBody ? signInBody : 'Click the link to sign into the App. _LINK',
      signInBodyLinkText: signInBodyLinkText ? signInBodyLinkText : null,
      params,
      pwaAppName,
      logSignInAttemptsToDatabase,
      customToken: validationCode
    }

    try {
      const response = await fn_cls.sendCustomTokenEmail(notificationData)
      console.log('response', response)
      const _sirProps = { signInResponseType: dispatchSuccessType, creds }
      callback && callback(signInResponseData(_sirProps), parentCallback)
      return { success: true }
    } catch (error) {
      console.error(error)
      const _sirProps = { signInResponseType: dispatchNonSuccessType, error, creds }
      callback && callback(signInResponseData(_sirProps), parentCallback)
      return { success: false, error }
    }
  } else {
    console.error('No Email')
    const _sirProps = { signInResponseType: dispatchNonSuccessType, creds }
    callback && callback(signInResponseData(_sirProps))
    return { success: false, error: 'No Email' }
  }
}



/**
 * updates `_appUserPasscodeValidation` with the validationCode and customToken
 * @param {*} creds 
 * @param {*} res 
 * @param {*} validationCode 
 * @param {*} callback 
 */
export const appUserPasscodeValidation_update = async (database_fns, creds, res, validationCode, callback) => {
  const { email } = creds ?? {}
  const { success, result } = res ?? {}
  const { customToken } = result ?? {}
  const _refPath = createRefPath([_collectionName_passcodeValidation, email])
  const dataToSet = { success: success, validationCode, customToken, acceptedTimestamp: serverTimestamp() }
  await database_fns.set_doc(_refPath, dataToSet)
  callback(res)
}